"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarNavigation = void 0;
var _styledComponents = require("styled-components");
var CalendarNavigation = exports.CalendarNavigation = (0, _styledComponents.css)([".react-datepicker__navigation{", " top:50px;border-width:0.7rem;outline:none;}"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && 'display: none;';
});